import { useNavigate } from 'react-router-dom'
import useSWR from 'swr'

import { useI18N } from '../../../libraries/i18n/hook'
import StudiesForm from '../../containers/users/StudiesForm'
import { getUserStudies } from '../../../api/users'
import Loading from '../../components/layout/Loading'
import OnBoardingHeader from './Header'

const OnboardingStudies = () => {
  const { t } = useI18N()
  const navigate = useNavigate()
  const { data, isLoading } = useSWR('/users/studies', getUserStudies)

  const onSuccess = () => {
    navigate('/onboarding/preferences')
  }
  if(isLoading) return <Loading />
  return (
    <>
      <OnBoardingHeader title={t('onboarding.studies.title')} description={t('onboarding.studies.description')} />
      <StudiesForm onSuccess={onSuccess} defaultValues={data} />
    </>
  )
}
export default OnboardingStudies
